<template>
  <section id="pricing">
    <v-container>
      <!-- Título y descripción en lugar de los tabs -->
      <v-row justify="center" class="mb-4">
        <v-col cols="12" class="text-center">
          <h2 class="mb-4">Elige tu plan</h2>
          <p class="subtitle-1">Selecciona la opción que mejor se adapte a tus necesidades</p>
        </v-col>
      </v-row>

      <!-- Banner promocional destacado -->
          <v-alert
          v-if="showDiscount"
            color="#F0F9F0"
            class="promo-banner text-center mb-12"
            style="border-radius: 16px; border: 2px dashed #4dd453; background-color: #f0ffec;"
          >
          <div class="font-weight-bold mb-1 d-flex align-center justify-center font-rubik">
            <v-icon small class="mr-2">mdi-ticket-percent</v-icon>
            ¡OFERTA ESPECIAL! {{ countdownText }} con hasta 40% de descuento
            </div>
            <div class="mb-2 font-rubik" style="font-size: 14px; color: #4B4B4B">
              Obtén hasta un <strong>40% de descuento</strong> en cualquier plan Premium.
            </div>
          </v-alert>
          
    </v-container>

    <div style="max-width: 1200px;" class="mx-auto"
    >
      <div class="justify-center d-flex flex-wrap"
    :class="$vuetify.breakpoint.smAndDown ? 'd-flex flex-column align-center' : ''"
      >
        <!-- Plan Gratuito -->
        <div class="mb-6 mx-4 pricing-card-container">
          <v-card class="pricing-card h-100" :elevation="2" outlined>
            <div class="d-flex flex-column align-center justify-center">
              <v-card-text class="pa-6">
                <h2 class="mb-6" style="font-size: 1.5rem; font-weight: 600;">Gratuito</h2>

                <p class="mb-6" style="color: #616161; line-height: 1.7;">
                  Prueba nuestras potentes herramientas de estudio con funciones esenciales sin costo.
                </p>

                <div class="d-flex align-end mb-2">
                  <span class="font-weight-bold price-text" style="font-size: 30px; max-height: auto;">
                    €0
                  </span>
                  <span class="ml-1 grey--text">EUR</span>
                </div>
                <div class="grey--text mb-6">
                  para siempre
                </div>

                <v-btn block height="48" class="mb-8 regular-btn" @click="$router.push('/app')" depressed
                  style="font-size: 16px;">
                  <span v-if="!isStartPlan">Registrarse</span>
                  <span v-else>Comenzar</span>
                </v-btn>

                <div class="mb-2 font-weight-medium">Qué incluye:</div>
                <ul class="feature-list pa-0">
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Chat IA</b> con tus documentos (3 preguntas al dia)'"></span>
                    </div>
                  </li>
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Generación</b> de 1 estudio inteligente al dia (cuestionarios, resumenes y tarjetas de un documento)'"></span>
                    </div>
                  </li>
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Ver apuntes</b> de la comunidad'"></span>
                    </div>
                  </li>
                </ul>
              </v-card-text>
            </div>
          </v-card>
        </div>
        
        <!-- Plan Premium Semanal -->
        <div class="mb-6 mx-4 pricing-card-container">
          <v-card class="pricing-card h-100" :class="{'popular-plan': popularPlan === 'weekly'}" :elevation="popularPlan === 'weekly' ? 10 : 2" outlined>
            <div :class="{'popular-plan-inside d-flex flex-column align-center justify-center': popularPlan === 'weekly', 'd-flex flex-column align-center justify-center': popularPlan !== 'weekly'}">
              <div v-if="popularPlan === 'weekly'" class="popular-badge px-3 py-1">Más Popular</div>

              <v-card-text class="pa-6" :class="{'pt-10': popularPlan === 'weekly'}">
                <h2 class="mb-6" style="font-size: 1.5rem; font-weight: 600;">Premium Semanal</h2>

                <p class="mb-6" style="color: #616161; line-height: 1.7;">
                  Prueba nuestras funciones premium por una semana. Perfecto para proyectos específicos o exámenes.
                </p>

                <div class="d-flex align-end mb-2">
                  <span v-if="showDiscount" class="font-weight-regular text-decoration-line-through mr-2" style="font-size: 18px; color: #888;">
                    €4,99
                  </span>
                  <span class="font-weight-bold price-text" :style="showDiscount ? 'color: #ff5252; font-size: 30px;' : 'font-size: 30px;'">
                    €{{ showDiscount ? '2,99' : '4,99' }}
                  </span>
                  <span class="ml-1 grey--text">EUR</span>
                </div>
                <div class="grey--text mb-6">
                  a la semana
                </div>

                <v-btn block height="48" class="mb-8 regular-btn" @click="selectPlan('premium', false, true)" depressed
                  style="font-size: 16px;">
                  Comenzar
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>

                <!-- Oferta limitada -->
                <div class="text-center mb-4 offer-tag">
                  <span class="limited-tag">
                    <v-icon x-small left>mdi-clock</v-icon>
                    {{ countdownText }} con hasta 40% descuento
                  </span>
                </div>

                <div class="mb-2 font-weight-medium">Qué incluye:</div>
                <ul class="feature-list pa-0">
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Chat IA</b> con tus documentos y asistente académico especializado'"></span>
                    </div>
                  </li>
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Generación ilimitada</b> de cuestionarios, resúmenes y tarjetas de estudio'"></span>
                    </div>
                  </li>
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Modo anónimo</b> para tus documentos personales'"></span>
                    </div>
                  </li>
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Recursos premium</b> y contenido inteligente de la comunidad'"></span>
                    </div>
                  </li>
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Descarga</b> de todo el material'"></span>
                    </div>
                  </li>
                </ul>
                <div class="text-center mb-4" style="font-size: 0.8em; color: #666;">
                  *Ilimitado hasta superar 15 documentos a la semana
                </div>
              </v-card-text>
            </div>
          </v-card>
        </div>

        <!-- Plan Premium Mensual -->
        <div class="mb-6 mx-4 pricing-card-container">
          <v-card class="pricing-card h-100" :class="{'popular-plan': popularPlan === 'monthly'}" :elevation="popularPlan === 'monthly' ? 10 : 2" outlined>
            <div :class="{'popular-plan-inside d-flex flex-column align-center justify-center': popularPlan === 'monthly', 'd-flex flex-column align-center justify-center': popularPlan !== 'monthly'}">
              <div v-if="popularPlan === 'monthly'" class="popular-badge px-3 py-1">Más Popular</div>

              <v-card-text class="pa-6" :class="{'pt-10': popularPlan === 'monthly'}">
                <h2 class="mb-6" style="font-size: 1.5rem; font-weight: 600;">Premium Mensual</h2>

                <p class="mb-6" style="color: #616161; line-height: 1.7;">
                  Optimiza tu estudio con IA avanzada y herramientas ilimitadas para maximizar tu rendimiento académico.
                </p>

                <div class="d-flex align-end mb-2">
                  <span v-if="showDiscount" class="font-weight-regular text-decoration-line-through mr-2" style="font-size: 18px; color: #888;">
                    €8,99
                  </span>
                  <span class="font-weight-bold price-text" :style="showDiscount ? 'color: #ff5252; font-size: 36px;' : 'font-size: 36px;'">
                    €{{ showDiscount ? '6,99' : '8,99' }}
                  </span>
                  <span class="ml-1 grey--text">EUR</span>
                </div>
                <div class="grey--text mb-2">
                  al mes
                </div>

                <v-btn block color="primary" height="48" class="mb-8 premium-btn" @click="selectPlan('premium', true)" depressed
                  style="font-size: 16px;">
                  Comenzar Ahora
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
                
                <!-- Oferta limitada -->
                <div class="text-center mb-4 offer-tag">
                  <span class="limited-tag">
                    <v-icon x-small left>mdi-clock</v-icon>
                    {{ countdownText }} con hasta 20% descuento
                  </span>
                </div>

                <div class="mb-2 font-weight-medium">Qué incluye:</div>
                <ul class="feature-list pa-0">
                  <li class="d-flex align-start mb-3">  
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Chat IA</b> con tus documentos y asistente académico especializado'"></span>
                    </div>
                  </li>
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Generación ilimitada</b> de cuestionarios, resúmenes y tarjetas de estudio'"></span>
                    </div>
                  </li>
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Modo anónimo</b> para tus documentos personales'"></span>
                    </div>
                  </li>
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Recursos premium</b> y contenido inteligente de la comunidad'"></span>
                    </div>
                  </li>
                  <li class="d-flex align-start mb-3">
                    <div style="width: 16px; height: 16px;" class="mr-2">
                      <lucide-check-circle color="#4dd453" class="mt-1" :size="16"></lucide-check-circle>
                    </div>
                    <div>
                      <span v-html="'<b>Descarga</b> de todo el material'"></span>
                    </div>
                  </li>
                </ul>
                <div class="text-center mb-4" style="font-size: 0.8em; color: #666;">
                  *Ilimitado hasta superar 50 documentos al mes
                </div>
              </v-card-text>
            </div>
          </v-card>
        </div>
        </div>
        
       
    </div>
  </section>
</template>

<script>
import { ArrowRight, ShieldCheck, Check } from 'lucide-vue'

export default {
  name: 'PricingSection',
  components: {
    LucideArrowRight: ArrowRight,
    LucideShieldCheck: ShieldCheck,
    LucideCheckCircle: Check
  },
  props: {
    billingType: {
      type: String,
      default: 'annually'
    },
    isStartPlan: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDiscount: true,
      countdownText: "2 días",
      timer: null,
      popularPlan: 'weekly',
      // popularPlan: 'monthly'
    }
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    startCountdown() {
      // Configurar fecha final del countdown (11 de junio de 2025)
      const endTime = new Date('2025-06-11T23:59:59');
      
      this.timer = setInterval(() => {
        const now = new Date();
        const timeLeft = endTime - now;
        
        if (timeLeft <= 0) {
          this.countdownText = "¡Oferta terminada!";
          clearInterval(this.timer);
          return;
        }
        
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
        
        if (days > 0) {
          this.countdownText = `${days}d ${hours}h ${minutes}m`;
        } else if (hours > 0) {
          this.countdownText = `${hours}h ${minutes}m ${seconds}s`;
        } else {
          this.countdownText = `${minutes}m ${seconds}s`;
        }
      }, 1000);
    },
    selectPlan(planId, isMonthly = false, isWeekly = false) {
      if (this.isStartPlan && this.$root.currentUser && this.$root.currentUser.value) {
        let params = '?planId=' + planId + '&discount=' + this.showDiscount;
        if (isWeekly) {
          params += '&weekly=true';
        } else if (!isMonthly) {
          params += '&anual=true';
        }
        this.$router.push('/go-to-premium' + params);
      } else {
        let params = '?planId=' + planId + '&discount=' + this.showDiscount;
        if (isWeekly) {
          params += '&weekly=true';
        } else if (isMonthly) {
          params += '&monthly=true';
        }
        this.$router.push('/login' + params);
      }
    }
  }
}
</script>

<style scoped>

.promo-banner code {
  background-color: rgba(77, 212, 83, 0.1);
  color: #4dd453;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
}

.start-plan-container {
  background: linear-gradient(135deg, #f8feff, #f5f9f5);
  min-height: 100vh;
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
}

.promo-code {
  background-color: white;
  color: #4dd453;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 6px;
  letter-spacing: 1px;
  border: 1px dashed #4dd453;
}

.promo-banner {
  animation: pulse-border 2s infinite;
}

@keyframes pulse-border {
  0% {
    box-shadow: 0 0 0 0 rgba(77, 212, 83, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(77, 212, 83, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(77, 212, 83, 0);
  }
}

.offer-tag {
  margin-top: -25px;
  margin-bottom: 20px;
}

.limited-tag {
  background-color: #fff0ec;
  color: #ff6347;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 12px;
  border: 1px solid #ffd0c6;
  display: inline-flex;
  align-items: center;
}

.limited-tag .v-icon {
  margin-right: 4px;
}

/* Estilos para tarjetas de precios */
.pricing-card-container {
  width: 100%;
  max-width: 340px;
}

.pricing-card {
  width: 100%;
  transition: all 0.3s ease;
  border-radius: 20px !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08) !important;
  overflow: hidden;
  border: 1px solid #d6e9daab !important;
}

.premium-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 800 !important;
  font-size: 1.05rem !important;
  border-radius: 16px !important;
  transition: filter 0.2s ease, transform 0.1s ease !important;
  border: 2px solid #4dd453 !important;
  height: 44px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  background-color: #4dd453 !important;
  box-shadow: 0 4px 0 #42b848 !important;
  color: white !important;
}

.regular-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
  font-size: 1.05rem !important;
  border-radius: 16px !important;
  transition: filter 0.2s ease, transform 0.1s ease !important;
  border: 1px solid #e0e0e0 !important;
  height: 46px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  background-color: white !important;
  box-shadow: 0 4px 0 #b5b5b5 !important;
  color: #424242 !important;
}

.pricing-card:hover {
  box-shadow: 0 16px 35px rgba(0, 0, 0, 0.12) !important;
}

.popular-plan {
  transform: scale(1.05);
  background-color: white !important;
}

.popular-plan-inside {
  margin: 5px;
  border-radius: 16px !important;
  border: 1px solid #f0f0f0ab !important;
  background-color: #f6faf5 !important;
}

.popular-badge {
  top: 10px;
  left: 10px;
  right: 0;
  position: absolute;
  width: fit-content;
  background: #dbffd4;
  color: #4CAF50;
  padding: 2px 6px;
  border-radius: 8px !important;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #bdebbd;
}

.discount-chip {
  background-color: #dbffd4 !important;
  color: #4CAF50 !important;
  font-weight: 700 !important;
  border-radius: 50px !important;
  font-size: 0.8rem;
  padding: 2px 8px !important;
}

/* Estilo para la badge de planes */
.badge-wrapper {
  display: flex;
  align-content: center;
  justify-content: center;
}

.pricing-badge {
  background: #fff;
  color: #4dd453;
  border-radius: 16px;
  padding: 4px 8px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-content: center;
  justify-content: center;
  width: fit-content;
  border: 1px solid #e9e9e9
}

/* Estilos para la garantía de devolución */
.money-back-guarantee {
  background-color: #fff;
  color: #4dd453;
  border-radius: 100px;
  font-weight: 800;
  padding: 12px 24px;
  border: 2px solid #e5f8d3;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Estilos para el gradiente de texto */
.price-text {
  color: #298e2d;
  font-weight: 500 !important;
}

/* Estilos para lista de características */
.feature-list {
  list-style-type: none;
  padding-left: 0;
}

.feature-list li {
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
}

.feature-list li span {
  font-size: 0.8rem;
  font-weight: 500;
  color: #4b4b4b;
  padding-top: 2px;
}

@media (max-width: 959px) {
  .popular-plan {
    transform: scale(1);
  }

  .popular-plan:hover {
    transform: translateY(-5px);
  }
}

.promo-applied {
  background-color: #f0ffec;
  color: #4dd453;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 12px;
  border: 1px solid #d6e9daab;
  display: inline-flex;
  align-items: center;
}
</style>